import aclMeta, { userTypePageAcl } from '@/router/consts'
import {
  eCircularRouteNames,
  directoryRouteNames,
  dashboardRouterNames,
  projectRouteNames,
  tenderRouteNames,
  FEATURE_NAMES,
} from '@/utils/consts'
import { ExportContactsRouteNames, ROUTER_PATHS } from '@/constants/router'

const prefix = ''
const userTypeAcl = userTypePageAcl.engineer

const HKLDHome = () => import('@/pages/Home')
const HKLDProfile = () => import('@/pages/Profile')
const IntLogin = () => import('@/pages/Login')
const ADLoginIn = () => import('@/pages/ADLogIn')
const Tenders = () => import('@/pages/tenders/ViewAll')
const Projects = () => import('@/pages/projects/ViewAll')
const Settings = () => import('@/pages/Settings')
const Contacts = () => import('@/modules/contacts/ContactsIndex')
const Performance = () => import('@/modules/performance/index')

const EngineerDashboard = () => import('@/pages/dashboards/EngineerView')
const AllTenancyRecords = () => import('@/pages/dashboards/AllTenancyRecords')

const TenderDetails = () => import('@/pages/tenders/Edit')
const TenderDetailsView = () => import('@/pages/tenders/View')

const TenderAddendumDetailsView = () => import('@/pages/tenders/addendum/View')
const TenderAddendumDetails = () => import('@/pages/tenders/addendum/Edit')

const Department = () => import('@/pages/department')
const SiteProfile = () => import('@/modules/settings/engineers/SiteProfile')
const LocationList = () => import('@/modules/settings/engineers/LocationList')
const BuildingList = () => import('@/modules/settings/engineers/BuildingList')
const BuildingListDetail = () => import('@/modules/settings/engineers/BuildingListDetail')
const BuildingDetail = () => import('@/pages/settings/BuildingDetail')
const BuildingTemplate = () => import('@/modules/settings/engineers/BuildingTemplate')
const BuildingHandoverTemplates = () => import('@/modules/settings/engineers/BuildingHandoverTemplates')
const SecurityGroup = () => import('@/modules/settings/engineers/SecurityGroup')
const SecurityGroupDetail = () => import('@/modules/settings/engineers/SecurityGroupDetail')
const Users = () => import('@/modules/settings/engineers/Users')
const HKLUserDetail = () => import('@/modules/settings/engineers/HKLUserDetail')
const AllVendors = () => import('@/modules/settings/vendors/AllVendors')
const VendorDetail = () => import('@/modules/settings/vendors/VendorDetail')
const AllTenants = () => import('@/modules/settings/tenants/AllTenants')
const TenantDetail = () => import('@/modules/settings/tenants/TenantDetail')
const TenancyUserDetail = () => import('@/modules/settings/tenants/TenancyUserDetail')
const UploadedFiles = () => import('@/modules/settings/engineers/UploadedFiles')
const AuditLog = () => import('@/modules/settings/engineers/AuditLog')
const SignatureTemplateForTenant = () => import('@/modules/settings/engineers/SignatureTemplate')
const SignatureTemplateForVendor = () => import('@/modules/settings/engineers/SignatureTemplate')
const Guideline = () => import('@/modules/settings/engineers/GuidelineSetting')
const AuditReport = () => import('@/modules/settings/engineers/AuditReport')
const userGuideAndForms = () => import('@/modules/settings/engineers/userGuideAndForms')
const RegionConfig = () => import('@/modules/settings/engineers/RegionConfigIndex')
const SystemMapping = () => import('@/modules/settings/engineers/SystemMapping')

const Addendum = () => import('@/modules/tenders/review/Addendum')
const AnalysisRecos = () => import('@/modules/tenders/review/AnalysisRecos')
const Comparison = () => import('@/pages/tenders/Comparison')
const HealthCheck = () => import('@/modules/tenders/review/HealthCheck')
const QueryStatus = () => import('@/modules/tenders/review/QueryStatus')
const Summary = () => import('@/pages/tenders/Summary')

const ProjectDetail = () => import('@/pages/projects/ProjectDetail')
const ProjectRatingHistory = () => import('@/modules/ccd/companies/ProjectRatingHistory')

const CompanyDetail = () => import('@/pages/ccd/CompanyDetail')
const CcdContactDetail = () => import('@/pages/ccd/ContactDetail')
const CcdTenancyDetail = () => import('@/pages/ccd/TenancyDetail')
const CcdTenancyView = () => import('@/pages/ccd/TenancyView')
const TenancyAllECircular = () => import('@/modules/ccd/tenancy/TenancyAllECircular')
const TenantCompanySelectorTest = () => import('@/pages/dev/TenancyCompanySelectorTest')

const HandoverTakeback = () => import('@/modules/hotb/HandoverTakeback')
const CreateTenantProject = () => import('@/modules/tenantProjects/information/CreateTenantProject')
const TenantProject = () => import('@/modules/tenantProjects/TenantProject')
const AllTenantProjects = () => import('@/modules/tenantProjects/AllTenantProjects')

const ECircularHistory = () => import('@/modules/eCircular/ECircularHistory')
const CreateECircular = () => import('@/modules/eCircular/CreateECircular')
const ECircularDetail = () => import('@/modules/eCircular/ECircularDetail')
const AddRecipients = () => import('@/modules/eCircular/AddRecipients')
const EcircularHistorySummary = () => import('@/modules/eCircular/historySummary')

const AllWorkPermits = () => import('@/modules/workPermits/AllWorkPermits')
const WorkPermitDashboard = () => import('@/pages/dashboards/WorkPermitView')
const StandaloneWp = () => import('@/modules/workPermits/StandaloneWp')

const AllDirectories = () => import('@/modules/directories/AllDirectories')
const Directories = () => import('@/modules/directories/List')
const DirectoryArchived = () => import('@/modules/directories/DirectoryArchived')
const DirectoryOrder = () => import('@/modules/directories/DirectoryOrder')
const DirectoryDetail = () => import('@/modules/directories/DetailView')
const DirectoryEdit = () => import('@/modules/directories/Edit')

const ExportContacts = () => import('@/pages/ExportContacts')
const ExportEmergency = () => import('@/pages/ccd/ExportEmergency')
const ExportMarketing = () => import('@/pages/ccd/ExportMarketing')
const ExportFireMarshal = () => import('@/pages/ccd/ExportFireMarshal')
const ExportWorker = () => import('@/modules/workPermits/ExportWorker')
const ExportWorkPermits = () => import('@/modules/workPermits/ExportWorkPermits')

const settingsChildren = [
  {
    path: 'users',
    name: ROUTER_PATHS.SETTING_USERS,
    component: Users,
    meta: { acl: aclMeta.settingsUsers },
  },
  {
    path: 'sites',
    name: ROUTER_PATHS.SITES,
    component: LocationList,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'sites/:id',
    name: ROUTER_PATHS.SITE_PROFILE,
    component: SiteProfile,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'location-list',
    name: ROUTER_PATHS.LOCATION_LIST,
    component: LocationList,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'building-list',
    name: ROUTER_PATHS.BUILDING_LIST,
    component: BuildingList,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'building-list-detail/:id',
    name: ROUTER_PATHS.BUILDING_PROFILE,
    component: BuildingListDetail,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'building-template',
    name: ROUTER_PATHS.BUILDING_TEMPLATE,
    component: BuildingTemplate,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'security-group',
    name: ROUTER_PATHS.SECURITY_GROUP,
    component: SecurityGroup,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'security-group/:id',
    name: ROUTER_PATHS.SECURITY_GROUP_DETAIL,
    component: SecurityGroupDetail,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'users/vendors',
    name: ROUTER_PATHS.ALL_CONTRACTORS,
    component: AllVendors,
    meta: { acl: aclMeta.settingsUsers },
  },
  {
    path: 'users/vendors/:id',
    name: ROUTER_PATHS.VENDOR_DETAIL,
    component: VendorDetail,
    meta: { acl: aclMeta.settingsUsers },
  },
  {
    path: 'users/tenants',
    name: ROUTER_PATHS.ALL_TENANTS,
    component: AllTenants,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'users/tenants/:id',
    name: ROUTER_PATHS.TENANT_DETAIL,
    component: TenantDetail,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'users/tenancies/:id',
    name: ROUTER_PATHS.TENANCY_USER_DETAIL,
    component: TenancyUserDetail,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'users/:id',
    name: ROUTER_PATHS.HKL_USER_DETAIL,
    component: HKLUserDetail,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'uploadedfiles',
    name: ROUTER_PATHS.UPLOADED_FILE_SETTINGS,
    component: UploadedFiles,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'audit-log',
    name: ROUTER_PATHS.AUDIT_LOG,
    component: AuditLog,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'tenant-signature-template',
    name: ROUTER_PATHS.TENANT_SIGNATURE_TEMPLATE,
    component: SignatureTemplateForTenant,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'vendor-signature-template',
    name: ROUTER_PATHS.VENDOR_SIGNATURE_TEMPLATE,
    component: SignatureTemplateForVendor,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'guideline',
    name: ROUTER_PATHS.GUIDELINE,
    component: Guideline,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'audit-report',
    name: ROUTER_PATHS.AUDIT_REPORT,
    component: AuditReport,
    meta: { acl: aclMeta.settings },
  },
  {
    path: ROUTER_PATHS.SITE_PROFILE,
    name: 'siteProfile',
    component: userGuideAndForms,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'departments',
    name: ROUTER_PATHS.DEPARTMENT,
    component: Department,
    meta: { acl: aclMeta.settingsDeparts },
  },
  {
    path: 'departments/:id',
    name: ROUTER_PATHS.DEPARTMENT_PROFILE,
    component: Department,
    meta: { acl: aclMeta.settingsDeparts },
  },
  {
    path: 'user-guide-forms-manage',
    name: ROUTER_PATHS.USER_GUIDE_FORMS_MANAGE,
    component: userGuideAndForms,
    meta: { acl: aclMeta.settings },
  },
  {
    path: 'region-config',
    name: ROUTER_PATHS.REGION_CONFIG,
    component: RegionConfig,
    meta: { acl: aclMeta.settingsRegional },
  },
  {
    path: ROUTER_PATHS.SYSTEM_MAPPING_LIST,
    name: ROUTER_PATHS.SYSTEM_MAPPING_LIST,
    component: SystemMapping,
    meta: { acl: aclMeta.settings },
  },
]

const paths = {
  routes: [
    /**
     * HKLD engineer view
     */
    { path: '/login', name: dashboardRouterNames.login, component: IntLogin, meta: { userTypeAcl: () => true } },
    { path: '/adLogin', name: 'adLogin', component: ADLoginIn, meta: { userTypeAcl: () => true } },
    { path: '/home', name: 'home', component: HKLDHome },
    { path: '/profile', name: 'profile', component: HKLDProfile },
    { path: '/', name: 'engineerDashboard', component: EngineerDashboard },
    { path: '/work-permit-dashboard', name: 'workPermitDashboard', component: WorkPermitDashboard },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      children: settingsChildren,
    },
    {
      path: '/building-detail/:id/template/:tid',
      name: 'building-detail',
      component: BuildingDetail,
    },
    {
      path: '/building-handover-templates/:id',
      name: 'building-handover-templates',
      component: BuildingHandoverTemplates,
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: Contacts,
    },
    {
      path: '/performance',
      name: 'performance',
      component: Performance,
      meta: { acl: aclMeta.performance },
    },
    { path: '/tenders', name: tenderRouteNames.tenders, component: Tenders, meta: { acl: aclMeta.tenderView } },
    { path: '/tender/edit/:id', name: 'tenderDetails', component: TenderDetails, meta: { acl: aclMeta.tenderEdit } },
    { path: '/tender/:id', name: 'tenderDetailsView', component: TenderDetailsView, meta: { acl: aclMeta.tenderView } },
    { path: '/tender/addendum/:id', name: 'tenderAddendumDetailsView', component: TenderAddendumDetailsView, meta: { acl: aclMeta.tenderView } },
    { path: '/tender/addendum/edit/:id', name: 'tenderAddendumDetails', component: TenderAddendumDetails, meta: { acl: aclMeta.tenderAddendumEdit } },
    { path: '/comparison/:id', name: 'tenderComparison', component: Comparison, meta: { acl: aclMeta.tenderView } },
    { path: '/summary/:id',
      name: 'tenderSummary',
      component: Summary,
      redirect: `/summary/:id/health-check`,
      meta: { acl: aclMeta.tenderView },
      children: [
        {
          path: 'analysis-recos',
          name: 'analysisRecos',
          component: AnalysisRecos,
        },
        {
          path: 'health-check',
          name: 'healthCheck',
          component: HealthCheck,
        },
        {
          path: 'addendum',
          name: 'addendumSummary',
          component: Addendum,
        },
        {
          path: 'query',
          name: 'queryStatus',
          component: QueryStatus,
        },
      ],
    },
    /* TM view */
    { path: '/tm/tender/:id', name: 'tmView', component: TenderDetailsView, meta: { acl: aclMeta.tenderView } },

    { path: '/projects', name: projectRouteNames.projects, component: Projects },
    { path: '/projects/:id', name: 'projectDetail', component: ProjectDetail, meta: { acl: aclMeta.projectView } },

    /**
     * ccd
     */
    { path: '/companies/detail/:id', name: 'companyView', component: CompanyDetail, meta: { acl: aclMeta.companyDetail } },
    { path: '/companies/create', name: 'companyCreate', component: CompanyDetail, meta: { acl: aclMeta.companyCreate } },
    { path: '/companies/edit/:id', name: 'companyEdit', component: CompanyDetail, meta: { acl: aclMeta.companyDetailCreateUpdate } },
    { path: '/companies/performanceRatingHistory/:filter', name: 'performanceRatingHistory', component: ProjectRatingHistory, meta: { acl: aclMeta.projectRatingHistory } },

    { path: '/ccdcontacts/detail/:id', name: 'ccdContactView', component: CcdContactDetail, meta: { acl: aclMeta.ccdContactDetail } },
    { path: '/ccdcontacts/create', name: 'ccdContactCreate', component: CcdContactDetail, meta: { acl: aclMeta.ccdContactDetailCreateUpdate } },
    { path: '/ccdcontacts/edit/:id', name: 'ccdContactEdit', component: CcdContactDetail, meta: { acl: aclMeta.ccdContactDetailCreateUpdate } },

    { path: '/tenancies/ecirculars/:id', name: 'ccdTenancyECirculars', component: TenancyAllECircular, meta: { acl: aclMeta.tenancyRecord } },
    { path: '/tenancies/view/:id', name: 'ccdTenancyView', component: CcdTenancyView, meta: { acl: aclMeta.tenancyRecord } },
    { path: '/tenancies/create', name: 'ccdTenancyCreate', component: CcdTenancyDetail, meta: { acl: aclMeta.tenancyRecordCreateUpdate } },
    { path: '/tenancies/edit/:id', name: 'ccdTenancyEdit', component: CcdTenancyDetail, meta: { acl: aclMeta.tenancyRecordCreateUpdate } },
    { path: '/tenancies/:id/directories', name: 'tenancyDirectories', component: Directories, meta: { acl: aclMeta.directory } },
    { path: '/dev/tenancy-company-name', name: 'tenantCompanySelectorTest', component: TenantCompanySelectorTest },

    {
      path: '/export-contacts',
      name: ExportContactsRouteNames.exportContacts,
      component: ExportContacts,
      meta: { acl: aclMeta.exportContacts },
      children: [
        {
          path: 'emergency',
          name: ExportContactsRouteNames.exportEmergency,
          component: ExportEmergency,
          meta: { acl: aclMeta.exportEmergency },
        },
        {
          path: 'marketing',
          name: ExportContactsRouteNames.exportMarketing,
          component: ExportMarketing,
          meta: { acl: aclMeta.exportMarketing },
        },
        {
          path: 'worker',
          name: ExportContactsRouteNames.exportWorker,
          component: ExportWorker,
          meta: { acl: aclMeta.workPermit },
        },
        {
          path: 'work-permits',
          name: ExportContactsRouteNames.exportWorkPermits,
          component: ExportWorkPermits,
          meta: { acl: aclMeta.exportWorkPermits, feature: FEATURE_NAMES.WORK_PERMITS },
        },
        {
          path: 'fire-marshal',
          name: ExportContactsRouteNames.exportFireMarshal,
          component: ExportFireMarshal,
          meta: { acl: aclMeta.exportFireMarshal },
        },
      ],
    },

    { path: '/allTenancyRecs', name: 'allTenancyRecs', component: AllTenancyRecords },
    /**
     * handover takeback
     */
    { path: '/handover-takeback/:id', name: 'handover', component: HandoverTakeback, meta: { acl: aclMeta.hotb } },

    /**
     * tenant projects
     */
    { path: '/tenant-projects/:id/edit', name: 'editTenantProject', component: CreateTenantProject },
    { path: '/tenant-projects/:id', name: 'tenantProject', component: TenantProject },
    { path: '/tenant-projects', name: 'allTenantProjects', component: AllTenantProjects },

    /**
     * E-Circular
     */
    { path: '/e-circulars/:type', name: eCircularRouteNames.eCircularHistory, component: ECircularHistory },
    { path: '/e-circulars/edit/:id', name: eCircularRouteNames.createECircular, component: CreateECircular, meta: { acl: aclMeta.eCircularCreate } },
    { path: '/e-circulars/detail/:id', name: eCircularRouteNames.eCircularDetail, component: ECircularDetail, meta: { acl: aclMeta.eCircularDetail } },
    { path: '/e-circulars/add-recipients/:id', name: eCircularRouteNames.addRecipients, component: AddRecipients, meta: { acl: aclMeta.eCircularAddRecipient } },
    { path: '/e-circulars/:id/history-summary/:hid', name: eCircularRouteNames.eCircularHistorySummary, component: EcircularHistorySummary },

    /**
     * Work Permit
     */
    { path: '/work-permits', name: 'allWorkPermits', component: AllWorkPermits },
    { path: '/standalone-wp/:id', name: 'engineerStandaloneWp', component: StandaloneWp },
    { path: '/hoisting-at-location', name: 'hoistingAtLocation', component: AllWorkPermits },
    /**
    * Directory
    */
    { path: '/directories', name: directoryRouteNames.directories, component: AllDirectories, meta: { acl: aclMeta.directory } },
    { path: '/directories/:id', name: directoryRouteNames.directoryDetail, component: DirectoryEdit, meta: { acl: aclMeta.directory } },
    { path: '/directories/:id/view', name: directoryRouteNames.directoryDetailView, component: DirectoryDetail, meta: { acl: aclMeta.directoryRead } },
    { path: '/directories-order', name: directoryRouteNames.directoryOrder, component: DirectoryOrder, meta: { acl: aclMeta.directoryMaintain } },
    { path: '/directories-archived', name: directoryRouteNames.directoryArchived, component: DirectoryArchived, meta: { acl: aclMeta.directoryRead } },
  ],
}

export default { prefix, paths, userTypeAcl }
